import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import _ from 'lodash';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class BrandCheckbox extends Component {

    shouldComponentUpdate(nextProps, nextState){
        return !_.isEqual(nextProps, this.props);
    }

    render() {
        const {brand, tailUrl, responsive, filterValue, query} = this.props;

        return (
            <li>
                {responsive
                ?   <label className="checkbox-container">{brand.brand_en}
                        <input type="checkbox" checked={filterValue} value={brand.brand_en} onChange={e => {this.props.setBrandFilter(e.target.checked)}} />
                        <span className="checkmark"><div className="checkmark-icon"></div></span>
                    </label>
                : <Link to={{pathname: "/shop/" + brand.brand_en + (tailUrl? ("/" + tailUrl): ""), search: query}}>{brand.brand_en}</Link>
                }
                
                
            </li>
        );
    }
}

function mapStateToProps(state) {
    return {
        filter: state.materials.filter,
    }
}
export default connect(mapStateToProps, {})(BrandCheckbox)